module.exports = __webpack_public_path__ + "img/Integrity-2022.7d33bd24.png";